<template>
  <div>
    <v-container>
      <validation-observer ref="observer">
        <form @submit.prevent="goToPageConfirmConnect">
          <v-row>
            <v-col>
              <template>
                <preview-template
                  v-model="templateSelect.content_json.chatBarText"
                  class="mt-12"
                ></preview-template>
              </template>
            </v-col>
            <v-col style="align-self: center">
              <v-card class="r0 pa-10">
                <template>
                  <h3 class="mt-1">
                    {{ $t('Step') }} 6 : {{ $t('Connect to LINE OA') }}
                    <v-btn
                      small
                      outlined
                      class="btn-custom right"
                      @click="howto()"
                    >
                      <span style="font-size: 11px">
                        {{ $t('How to connect') }} ?
                      </span>
                    </v-btn>
                  </h3>
                  <div class="mt-5">
                    <v-dialog
                      v-model="dialogSelectChannel"
                      persistent
                      max-width="800px"
                    >
                      <template #activator="{ on, attrs }">
                        <v-btn
                          v-bind="attrs"
                          color="primary"
                          class="text-none mb-2 mt-3"
                          rounded
                          depressed
                          @click="setCheckManagePage"
                          v-on="on"
                        >
                          <!-- :loading="isSelecting"
                          @click="onButtonClick" -->
                          {{
                            !buttonText
                              ? $t('Select your channel ID')
                              : buttonText
                          }}
                        </v-btn>
                        <v-btn
                          v-show="buttonText !== null"
                          icon
                          small
                          class="ml-2 mt-1 color-primary"
                          @click="clearBtn"
                        >
                          <v-icon> mdi-close</v-icon>
                        </v-btn>
                      </template>
                      <v-card style="padding-bottom: 20px">
                        <div
                          class="pointer"
                          style="
                            float: right;
                            margin-right: 30px;
                            margin-top: 10px;
                          "
                        >
                          <v-icon @click="dialogSelectChannel = false"
                            >mdi-close</v-icon
                          >
                        </div>
                        <v-card-title
                          class="pa-1"
                          style="place-content: center; display: block"
                        >
                          <!-- <h3 class="mt-3">Select your channel ID</h3> -->
                          <manage-project
                            @ActiveCreditCard="ActiveCreditCard"
                          ></manage-project> </v-card-title
                      ></v-card>
                    </v-dialog>
                  </div>
                </template>
                <!-- <template>
                  <div class="btn-sticky mt-5 pr-pl-12">
                    <v-btn
                      outlined
                      @click="back"
                      class="btn-back-richmenu w45 br-7"
                      >{{ $t("Back") }}</v-btn
                    >
                    <template>
                      <v-btn
                        outlined
                        class="btn-custom btn-next-richmenu w45 right"
                        :disabled="!buttonText"
                        type="submit"
                        ><span>{{ $t("save_and_connect") }}</span>
                      </v-btn>
                    </template>
                  </div>
                </template> -->
              </v-card>
              <p class="mt-5">
                {{
                  $t(
                    'Please make sure you are connect to this LINE OA account , You will not change after connected'
                  )
                }}
              </p>
              <hr />
              <div class="text-center mt-5">
                <p>
                  <v-switch
                    v-model="showAdvance"
                    inset
                    :label="$t('set_the_time_to_turn_on_rich_menu')"
                  ></v-switch>
                </p>
              </div>
            </v-col>
          </v-row>
          <v-card
            v-if="showAdvance"
            class="mt-5 r0"
            style="padding-bottom: 20px"
          >
            <v-card-title
              class="pa-1"
              style="place-content: center; display: block"
            >
              <select-date-form v-model="setDataTime"> </select-date-form>
            </v-card-title>
          </v-card>
          <confirm-connect
            v-if="dialog"
            v-model="dialog"
            :data-connect="dataConnect"
            :set-data-time="setDataTime"
            :show-advance="showAdvance"
            :select="select"
            :channel="Channel"
          ></confirm-connect>
          <template>
            <v-card class="command-bar">
              <div class="btn-sticky mt-5 pr-pl-12 sticky-left">
                <v-btn
                  outlined
                  style="width: 125px"
                  class="btn-back-richmenu br-7"
                  @click="back"
                  >{{ $t('Back') }}</v-btn
                >
              </div>
              <div class="btn-sticky mt-5 pr-pl-12 sticky-right">
                <v-btn
                  outlined
                  class="btn-custom btn-next-richmenu right"
                  style="width: 180px"
                  :disabled="!buttonText || !Channel"
                  type="submit"
                  ><span>{{ $t('save_and_connect') }}</span>
                </v-btn>
              </div>
            </v-card>
          </template>
        </form>
      </validation-observer>
    </v-container>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import PreviewTemplate from './PreviewTemplate'
import ConfirmConnect from './ConfirmConnect'
import ManageProject from '../account/ManageProject'
import moment from 'moment'
import SelectDateForm from './SelectDateForm.vue'
import dayjs from 'dayjs'
export default {
  components: {
    PreviewTemplate,
    ConfirmConnect,
    ManageProject,
    SelectDateForm
  },
  data() {
    return {
      showAdvance: false,
      select: null,
      dialog: false,
      dialogSelectChannel: false,
      dataConnect: {
        app: 'line',
        channel_id: '',
        channel_secret: '',
        platform_channel_id: ''
      },
      setDataTime: {
        date: dayjs().format('YYYY-MM-DD'),
        date2: dayjs().add(1, 'day').format('YYYY-MM-DD'),
        time: '00:00',
        time2: '00:00',
        weekDate: []
      }
    }
  },
  created() {},
  computed: {
    ...mapGetters({
      templateSelect: 'lineRichmenuManager/getTemplateSelect',
      lineRichmenu: 'lineRichmenuManager/getLineRichMenu',
      channelToken: 'channelIdManager/getChannelToken',
      Channel: 'channelIdManager/getChannel',
      packageRichmenu: 'getPackageRichmenu'
    }),
    buttonText() {
      return this.Channel
        ? `${this.Channel.channel_name} (${this.Channel.channel_id})`
        : null
    }
  },
  watch: {
    model(val) {
      if (val.length > 1) {
        this.$nextTick(() => this.model.pop())
      }
    }
  },
  async mounted() {
    const vm = this
    if (vm.templateSelect.package_id !== null) {
      await vm.$store.dispatch('channelIdManager/getChannelByAccount')
      if (vm.templateSelect.connected_channel_id) {
        var channel = vm.channelToken.find((el) => {
          return el.id == vm.templateSelect.connected_channel_id
        })
        if (channel)
          vm.$store.dispatch('channelIdManager/selectChannel', channel)
      } else vm.$store.dispatch('channelIdManager/selectChannel', null)

      vm.lineRichmenu.forEach((item) => {
        if (item.id === vm.templateSelect.id) {
          if (
            item.set_default_schedule &&
            item.set_default_schedule.length > 0
          ) {
            vm.showAdvance = true
          }
        }
      })
    } else {
      const path = `/${this.currentLang}/richmenu`
      if (vm.$route.path !== path) {
        vm.$router.push({ path })
      }
    }
  },
  methods: {
    async checkExpRichmenu() {
      let result = null
      var res = await this.$store.dispatch(
        'lineRichmenuManager/lineRichmenuPackageByAccount'
      )
      if (res) {
        res.data.data.map((item) => {
          if (item.id === this.templateSelect.package_id) {
            let a = moment(item.expired_timestamp)
            let b = moment()
            return (result = a.diff(b, 'days'))
          }
        })
        return result
      }
    },
    clearBtn() {
      this.$store.dispatch('channelIdManager/selectChannel', null)
    },
    howto() {
      var prefix = window.location.hostname == 'app.zwiz.ai' ? 'z_' : ''
      this.$gtag.event('event', {
        event_category: prefix + 'Step 6 How to connect'
        // event_label: bot.pagename + utm,
      })
      window.open('https://blog.zwiz.app/connectrichmenu/', '_blank')
    },

    setCheckManagePage() {
      var prefix = window.location.hostname == 'app.zwiz.ai' ? 'z_' : ''
      this.$gtag.event('event', {
        event_category: prefix + 'Step 6 Select your channet ID'
        // event_label: bot.pagename + utm,
      })
      this.$store.dispatch('channelIdManager/checkManagePage', true)
    },

    async ActiveCreditCard() {
      this.$nextTick(async () => {
        this.dataConnect.channel_id = this.Channel.channel_id
        this.dataConnect.channel_secret = this.Channel.channel_secret
        this.dataConnect.platform_channel_id = this.Channel.id
      })
      this.dialogSelectChannel = false
    },
    async goToPageConfirmConnect() {
      this.dialog = true
    },
    back() {
      this.$emit('goToPage', 6)
    }
  }
}
</script>

<style lang="scss" scoped></style>
